// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER



//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

function isTouchDevice() {
  return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
if (isTouchDevice() === true) {
  $("body").toggleClass("touch");
} else {
  $("body").toggleClass("no-touch");
}

// Section Passende Bekleidung für alle deine Aktivitäten
//-------------------------------------------------

const hovers =  document.querySelectorAll(".msdw-hover-text");

hovers.forEach(hover => {
    hover.addEventListener('click', () => hover.classList.toggle("active"))
});


//
// =PLACE SLOT MODULE INSIDE THE LP
// --------------------------------------------------
const sliderSlot = document.getElementById('msdwSliderSlot');
const catLandingBottom1 = document.getElementById('cat-landing-bottom1');
catLandingBottom1 && sliderSlot.appendChild(catLandingBottom1);
//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// $('.msdw-page-scroll').click(function() {
//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       var offsetValue = 0;
//       if ( window.innerWidth <= 767 ) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $('html,body').animate({
//         scrollTop: target.offset().top - offsetValue
//       }, 900);
//       return false;
//     }
//   }
// });


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

// *** IntersectionObserver ***

// const elements = document.querySelectorAll(".msdw-animate");

// function check(entries) {
//   entries.map((entry) => {
//     if (entry.isIntersecting) {
//       entry.target.classList.add("msdw-animated");
//       observer.unobserve(entry.target);
//     }
//   });
// }

// const observer = new IntersectionObserver(check);

// elements.forEach((elem) => observer.observe(elem));


// *** requestAnimationFrame ***

// const scroll = window.requestAnimationFrame;

// function showOnScroll() {
//   const elems = document.querySelectorAll('.msdw-animate');

//   elems.forEach((el) => {
//     const elPosition = el.getBoundingClientRect().top
//     const elScreen = window.innerHeight / .9

//     if (elPosition < elScreen) {
//       el.classList.add('msdw-animated')
//     }
//   });

//   scroll(showOnScroll);
// }

// showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

// var swiper = new Swiper('.swiper-container', {
//   slidesPerView: 1,
//   loop: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
// });


//
// =SLIDER (SLICK JS)
// --------------------------------------------------

// $('.msdw-slider-jacket').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   swipe: false,
//   arrows: false,
//   swipeToSlide: true,   // in case, 2 or more slides at a time
//   autoplay: true,       // if autoplay...
//   accessibility: false  // use this to avoid page jumping bug
// });

// $('.slick-prev').click(function() {
//   $('.msdw-slider-jacket').slick('slickPrev');
// });
//
// $('.slick-next').click(function() {
//   $('.msdw-slider-jacket').slick('slickNext');
// });

// UNSLICK
// If needed, here's a fix for window resizing
// $(window).on('orientationchange resize', function() {
//   $('.msdw-slider-jacket').slick('resize');
// });


//
// =PRODUCT PICKER
// --------------------------------------------------

// const productPickers = document.querySelectorAll('.msdw-product-detail-picker');

// productPickers.forEach(productPicker => {
//   const productIdNumber = productPicker.dataset.productId;
//   productPicker.addEventListener('click', (e) => {
//     e.preventDefault();
//     window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {
//       'productId': productIdNumber
//     });
//   });
// });


//
// =NEWSLETTER PICKER
// --------------------------------------------------

// var campaignId = 'familyAndFriends',
//     pickerTag = document.getElementById("openPicker"),
//     newsletterConfig = {},
//     baseUrl = jwsdwSettings.baseUrl;

// $.ajax({
//   type: 'GET',
//   url: baseUrl + '/Newsletter-getNewsletterConfig',
//   data: {
//     campaignId: campaignId
//   },
//   success: function(response) {
//     newsletterConfig = response
//   },
//   error: function(response) {
//     jwsdwApi.popup.showHttpError(response.status)
//   }
// });

// pickerTag.addEventListener("click", function(){
//   window.jwsdwMediator.publish('openPicker', 'newsletterSignupPicker', {
//     "campaign": newsletterConfig.id,
//     "introduction": newsletterConfig.introduction,
//     "disclaimerOne": newsletterConfig.disclaimerOne,
//     "disclaimerTwo": newsletterConfig.disclaimerTwo
//   });
// });

//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById("msdw-video-responsive");

function changeVideoSize(size) {
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-" + size));
  vid.autoplay = true;
  vid.load();
  console.log(videoSource.attr("src"));
}

function loadVideo() {
  var sm = window.matchMedia("(min-width: 0px) and (max-width: 599px)"), // Standard def (mp4, 640x360)
    md = window.matchMedia("(min-width: 600px) and (max-width: 899px)"), // Standard def (mp4, 960x540)
    lg = window.matchMedia("(min-width: 900px) and (max-width: 1199px)"), // High def (mp4, 1280x720)
    xl = window.matchMedia("(min-width: 1200px) and (max-width: 99999px)"); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if (sm.matches) {
    changeVideoSize("sm");
  } else if (md.matches) {
    changeVideoSize("md");
  } else if (lg.matches) {
    changeVideoSize("lg");
  } else if (xl.matches) {
    changeVideoSize("xl");
  }
}

if (document.contains(vid)) {
  document.addEventListener("DOMContentLoaded", loadVideo);
  vid.onloadeddata = () => vid.classList.add("msdw-video-loaded");
  window.onresize = loadVideo;
}
